import React, { useContext } from "react";
import { arenaLabPage } from "../../../portfolio";
import StyleContext from "../../../contexts/StyleContext";
import "./ArenaLabOpportunities.css";

export default function ArenaLabOpportunities() {
  const { isDark } = useContext(StyleContext);

  return (
    <div className="arena-lab-section opportunities-section" id="lab-opportunities">
      <h2 className="section-title">Join Our Lab</h2>
      <p className="opportunities-intro">
        We are always excited to work with talented researchers and students. Explore opportunities to join our team.
      </p>
      
      <div className="opportunities-grid">
        {arenaLabPage.opportunities.map((opp, index) => (
          <div key={index} className={`opportunity-card ${isDark ? "dark-mode" : ""}`}>
            <div className="opp-header">
              <h3 className="opp-title">{opp.position}</h3>
              <span className="opp-badge">{opp.type}</span>
            </div>
            
            <p className="opp-description">{opp.description}</p>
            
            {opp.duration && (
              <p className="opp-detail">
                <strong>Duration:</strong> {opp.duration}
              </p>
            )}
            
            {opp.requirements && opp.requirements.length > 0 && (
              <div className="opp-requirements">
                <strong>Requirements:</strong>
                <ul>
                  {opp.requirements.map((req, i) => (
                    <li key={i}>{req}</li>
                  ))}
                </ul>
              </div>
            )}
            
            {opp.deadline && (
              <p className="opp-deadline">
                📅 Application Deadline: {opp.deadline}
              </p>
            )}
            
            {opp.applyLinks && opp.applyLinks.length > 0 && (
              <div className="opp-actions">
                {opp.applyLinks.map((action, i) => (
                  <a
                    key={i}
                    href={action.url}
                    className={`opp-button ${i === 0 ? "primary" : "ghost"}`}
                    target={action.url.startsWith("http") ? "_blank" : "_self"}
                    rel={action.url.startsWith("http") ? "noreferrer" : undefined}
                  >
                    {action.label}
                  </a>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
